module.exports = "https://portperrypedals.ca/_res/img/scott-roy.b07f5bb.png";